import { render, staticRenderFns } from "./SportelloControlliView.vue?vue&type=template&id=65529d8a&"
import script from "./SportelloControlliView.vue?vue&type=script&lang=ts&"
export * from "./SportelloControlliView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports